/**
 * ActiveContextBuilder
 *
 * Centralised helper to construct a `CopilotContext` snapshot from the
 * current Vuex store state. This keeps context-gathering logic in a
 * single place so that future changes to how context is represented
 * in the UI only need to be made once.
 */
export function buildActiveContext(store) {
  const workspaceSelected = store.state.workspace.selected || {}
  const applicationSelected = store.state.application.selected || {}
  const tableSelected = store.state.table.selected || {}
  const viewSelected = store.state.view.selected || {}
  const gridState = store.state['page/view/grid'] || {}
  const rowModalNavState = store.state.rowModalNavigation || {}

  const workspaceId = workspaceSelected.id || null
  const applicationId = applicationSelected.id || null
  const tableId = tableSelected.id || null
  const viewId = viewSelected.id || null

  return {
    workspaceId,
    workspaceName: workspaceSelected.name || null,
    applicationId,
    applicationType: applicationSelected.type || null,
    tableId,
    tableName: tableSelected.name || null,
    viewId,
    viewType: viewSelected.type || null,
    // Grid-level navigation state.
    searchTerm: gridState.activeSearchTerm || '',
    hideRowsNotMatchingSearch:
      gridState.hideRowsNotMatchingSearch !== undefined
        ? gridState.hideRowsNotMatchingSearch
        : true,
    activeGroupBys: gridState.activeGroupBys || [],
    // Row-level state coming from the row modal navigation, if any.
    focusedRowId: rowModalNavState.row ? rowModalNavState.row.id : null,
  }
}

